import Navbar from "../components/Navbar";
import HowItWorks from "../components/HowItWorks";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";

export default function HowItWorksPage() {
    return (
        <div className="bg-background text-foreground min-h-screen">
            <Navbar />
            <main data-testid="how-it-works-page" className="pt-[7rem]">
                <HowItWorks />
                <FinalCTA />
            </main>
            <Footer />
        </div>
    );
}
